import { doGet } from "./BaseAPI";

export function getDomainProximity() {
  return doGet(`/organization/domainproximity/domain`);
}
